import { Buffer } from "buffer";

import { CLIENT_ID, CLIENT_SECRET } from "./constants";

export const getClientSecretBasicAuthHeader = () => {
  return { Authorization: `Basic ${Buffer.from(`${CLIENT_ID}:${CLIENT_SECRET}`).toString("base64")}` };
};
